var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', [_vm._v("群組保護")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("廣告黑名單(全店)管理")])], 1)], 1)])]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("廣告黑名單(全店)管理")]), _c('div', {
    staticClass: "row d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-4 d-flex align-items-center flex-nowrap my-3"
  }, [_c('h6', {
    staticClass: "mb-xl-0 font-weight-bold text-nowrap mr-2"
  }, [_vm._v("群組")]), _c('b-form-select', {
    attrs: {
      "options": _vm.groups.map(function (x) {
        return {
          text: "".concat(x.branch_code, " ").concat(x.name),
          value: x.guard_group_id
        };
      })
    },
    on: {
      "change": _vm.fecthGlobalBlackCustomers
    },
    scopedSlots: _vm._u([_vm.groups.length != 1 ? {
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": ""
          }
        }, [_vm._v("-- 請選擇 --")])];
      },
      proxy: true
    } : null], null, true),
    model: {
      value: _vm.currentGroupId,
      callback: function callback($$v) {
        _vm.currentGroupId = $$v;
      },
      expression: "currentGroupId"
    }
  })], 1), _c('div', {
    staticClass: "col-12 col-xl-4 d-flex flex-column flex-xl-row align-items-start align-items-xl-center my-3"
  }), _c('div', {
    staticClass: "col-12 col-xl-4 d-flex flex-column flex-xl-row align-items-start align-items-xl-center my-3"
  }, [_c('b-input-group', {
    staticClass: "ml-0 ml-xl-4"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋姓名/平台ID"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fecthGlobalBlackCustomers.apply(null, arguments);
      }
    },
    model: {
      value: _vm.keyword,
      callback: function callback($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.fecthGlobalBlackCustomers
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1), _c('div', {
    staticClass: "col-12 col-xl-4 d-flex align-items-center flex-nowrap my-3"
  }, [_c('h6', {
    staticClass: "mb-xl-0 font-weight-bold text-nowrap mr-2"
  }, [_vm._v("設定角色")]), _c('b-form-select', {
    attrs: {
      "options": _vm.roleOptions.filter(function (x) {
        return x.value != 'guard';
      })
    },
    model: {
      value: _vm.setRole,
      callback: function callback($$v) {
        _vm.setRole = $$v;
      },
      expression: "setRole"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null
    }
  }, [_vm._v("-請選擇角色-")])], 1), _c('b-button', {
    staticClass: "ml-2 text-nowrap",
    attrs: {
      "variant": "primary",
      "disabled": _vm.setRole == null || _vm.selectedCustomerGroups.length == 0
    },
    on: {
      "click": _vm.setRoleToCustomers
    }
  }, [_vm._v("設定")])], 1)]), _c('hr'), _c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "hover": "",
      "items": _vm.globalBlackCustomers,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(id)",
      fn: function fn(data) {
        return [_c('b-form-checkbox', {
          attrs: {
            "value": data.item.id
          },
          model: {
            value: _vm.selectedCustomerGroups,
            callback: function callback($$v) {
              _vm.selectedCustomerGroups = $$v;
            },
            expression: "selectedCustomerGroups"
          }
        })];
      }
    }, {
      key: "cell(avatar_url)",
      fn: function fn(data) {
        return [_c('b-img-lazy', _vm._b({
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !!data.item.avatar_url,
            expression: "!!data.item.avatar_url"
          }],
          staticClass: "rounded-circle",
          attrs: {
            "src": data.item.avatar_url
          }
        }, 'b-img-lazy', _vm.mainProps, false))];
      }
    }, {
      key: "cell(role)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.roleEnum(data.item.role).variant
          }
        }, [_vm._v(_vm._s(_vm.roleEnum(data.item.role).text))])];
      }
    }])
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }